let url =
  process.env.ENVIRONMENT === 'STG'
    ? 'https://l60xo7vpwj.execute-api.us-east-1.amazonaws.com/stg/nol'
    : process.env.ENVIRONMENT === 'PDN'
      ? 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/nol'
      : 'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/nol'

// Activity type Game
export const getTop = url + '/competition/api/v1/top-game'
export const getTokenGame = url + '/competition/api/v1/get-token-game'
export const postGameParticipationRedeem =
  url + '/competition/api/v1/game-participation-redeem'
export const postGameParticipationSave =
  url + '/competition/api/v1/game-participation-save'
export const getAccumulationsTotal =
  url + '/competition/api/v1/get-accumulation-total/'

export const getIsWinner = url + '/competition/api/v1/winner-prize'
export const getTickets = url + '/competition/api/v1/coupon-detail'
export const getProductKey = url + '/accumulation/api/v1/product-key'
export const postRedeemKeyWithoutPoints = url + '/accumulation/api/v1/key'
export const postRedeemParticipationGoal =
  url + '/competition/api/v1/obtain-prize'

//data policy service
export const dataPolicy = url + '/account/api/v1/data-policy'
